import { useState } from "react";
import {
  Button,
  Card,
  Form,
  Input,
  InputNumber,
  Space,
  Table,
  Tabs,
  Tag,
  message,
} from "antd";
import {
  useAdminOpenBetsQuery,
  useAdminSettleFancyMutation,
  useAdminSettleMatchMutation,
} from "../../../store/service/betSettlementService";

const BetSettlementAdmin = () => {
  const [matchFilter, setMatchFilter] = useState("");
  const [fancyForm] = Form.useForm();
  const [matchForm] = Form.useForm();

  const { data, isLoading, refetch } = useAdminOpenBetsQuery(
    matchFilter ? Number(matchFilter) : undefined
  );
  const [settleFancy, { isLoading: settlingFancy }] = useAdminSettleFancyMutation();
  const [settleMatch, { isLoading: settlingMatch }] = useAdminSettleMatchMutation();

  const bets = data?.data || [];

  const columns = [
    { title: "ID", dataIndex: "betId", width: 50 },
    { title: "User", dataIndex: "userId", width: 70 },
    { title: "Match", dataIndex: "matchId", width: 90 },
    { title: "Market", dataIndex: "marketType", width: 90 },
    {
      title: "Selection",
      dataIndex: "selection",
      ellipsis: true,
    },
    {
      title: "Type",
      dataIndex: "betType",
      render: (t) => (t === "back" ? "LAGAI/YES" : "KHAI/NO"),
    },
    { title: "Rate", dataIndex: "odds" },
    { title: "Stake", dataIndex: "stake" },
    { title: "Profit", dataIndex: "potentialWin" },
  ];

  const onSettleFancy = async () => {
    try {
      const values = await fancyForm.validateFields();
      const res = await settleFancy(values).unwrap();
      message.success(res.message);
      fancyForm.resetFields();
      refetch();
    } catch (err) {
      message.error(err?.data?.message || "Settle failed");
    }
  };

  const onSettleMatch = async () => {
    try {
      const values = await matchForm.validateFields();
      const res = await settleMatch(values).unwrap();
      message.success(res.message);
      matchForm.resetFields();
      refetch();
    } catch (err) {
      message.error(err?.data?.message || "Settle failed");
    }
  };

  return (
    <div style={{ padding: 16 }}>
      <h2>Bet Settlement</h2>
      <p style={{ color: "#666", marginBottom: 16 }}>
        Fancy: BACK (Yes) jeetta hai jab actual runs ≥ line rate. Profit = stake × rate ÷ 100.
        Jeet par stake + profit wallet me auto add.
      </p>

      <Tabs
        items={[
          {
            key: "open",
            label: `Open Bets (${bets.length})`,
            children: (
              <Card>
                <Space style={{ marginBottom: 12 }}>
                  <Input
                    placeholder="Filter match ID"
                    value={matchFilter}
                    onChange={(e) => setMatchFilter(e.target.value)}
                    style={{ width: 160 }}
                  />
                  <Button onClick={() => refetch()}>Refresh</Button>
                </Space>
                <Table
                  rowKey="betId"
                  loading={isLoading}
                  columns={columns}
                  dataSource={bets}
                  scroll={{ x: 900 }}
                  pagination={{ pageSize: 15 }}
                />
              </Card>
            ),
          },
          {
            key: "fancy",
            label: "Settle Fancy / Session",
            children: (
              <Card title="Session result declare karein">
                <Form form={fancyForm} layout="vertical" style={{ maxWidth: 480 }}>
                  <Form.Item name="matchId" label="Match ID" rules={[{ required: true }]}>
                    <InputNumber style={{ width: "100%" }} placeholder="35715694" />
                  </Form.Item>
                  <Form.Item
                    name="selection"
                    label="Session name (exact)"
                    rules={[{ required: true }]}
                    extra='Example: "12 over run AFG"'>
                    <Input placeholder="12 over run AFG" />
                  </Form.Item>
                  <Form.Item
                    name="actualRuns"
                    label="Actual runs (result)"
                    rules={[{ required: true }]}
                    extra="Agar 74 ya usse zyada aaye to BACK @74 jeet jayega">
                    <InputNumber style={{ width: "100%" }} min={0} placeholder="74" />
                  </Form.Item>
                  <Button type="primary" loading={settlingFancy} onClick={onSettleFancy}>
                    Settle Fancy Bets
                  </Button>
                </Form>
              </Card>
            ),
          },
          {
            key: "match",
            label: "Settle Match Winner",
            children: (
              <Card title="Bookmaker / Match Odds">
                <Form form={matchForm} layout="vertical" style={{ maxWidth: 480 }}>
                  <Form.Item name="matchId" label="Match ID" rules={[{ required: true }]}>
                    <InputNumber style={{ width: "100%" }} />
                  </Form.Item>
                  <Form.Item name="winnerTeam" label="Winner team" rules={[{ required: true }]}>
                    <Input placeholder="India" />
                  </Form.Item>
                  <Button type="primary" loading={settlingMatch} onClick={onSettleMatch}>
                    Settle Match Bets
                  </Button>
                </Form>
              </Card>
            ),
          },
        ]}
      />
    </div>
  );
};

export default BetSettlementAdmin;
